module.exports = __webpack_public_path__ + "img/drivers-indoor-point.66e93564.jpg";